// Creates an element for editing corrections.
class CorrectionsEditor extends CorrectorWidget {

	///////////////////////////////////////////////////////////////////////////////////////////
	//  CONSTRUCTOR
	///////////////////////////////////////////////////////////////////////////////////////////

	/*
	CONSTRUCTOR: Creates an instance of the Editor object. This will create the @element from the @html string and set up all events.

	options - An Object literal containing options. There are currently no options implemented.

	Examples:

	// Creates a new editor, adds a custom field and loads an correction for editing.

	editor = new CorrectionsEditor
	editor.addField({
		label: 'My custom input field',
		type:  'textarea'
		load:  someLoadCallback
		save:  someSaveCallback
	})
	editor.load(correction)

	Returns a new Editor instance.
	*/
	constructor(options) {
		// TODO: Can't use 'this' before super, so have to declare html local and use that, then set the class property
		const html = `\
<div class="corrector-outer corrections-editor">
  <form class="corrector-widget">
    <ul class="corrector-listing"></ul>
    <div class="corrector-controls">
      <a href="#cancel" class="corrector-cancel">` + _t('Cancel') + `</a>
<a href="#save" class="corrector-save corrector-focus">` + _t('Save') + `</a>
    </div>
  </form>
</div>\
`;
		super( $(html)[0], options );
	}

	properties() {
		super.properties();

		// HTML template for @element.
		this.html = `\
<div class="corrector-outer corrections-editor">
  <form class="corrector-widget">
    <ul class="corrector-listing"></ul>
    <div class="corrector-controls">
      <a href="#cancel" class="corrector-cancel">` + _t('Cancel') + `</a>
<a href="#save" class="corrector-save corrector-focus">` + _t('Save') + `</a>
    </div>
  </form>
</div>\
`;
		this.fields = [];
		this.correction = {};

		// Events to be bound to @element.
		this.events = this.events || {};
		this.events = $.extend(this.events, {
			"form submit":                 "submit",
			".corrector-save click":       "submit",
			".corrector-cancel click":     "hide",
			".corrector-cancel mouseover": "onCancelButtonMouseover",
			"textarea keydown":            "processKeypress"
		});

		// Classes to toggle state.
		this.classes = this.classes || [];
		this.classes = $.extend(this.classes, {
			hide:  'corrector-hide',
			focus: 'corrector-focus'
		});
	}

	///////////////////////////////////////////////////////////////////////////////////////////
	//  PUBLIC METHODS
	///////////////////////////////////////////////////////////////////////////////////////////

	/*
	PUBLIC: Displays the Editor and fires a "show" event.
	Can be used as an event callback and will call Event#preventDefault() on the supplied event.

	event - Event object provided if method is called by event listener (default:undefined)

	Examples:

	// Displays the editor.
	editor.show()

	// Displays the editor on click (prevents default action).
	$('a.show-editor').bind('click', editor.show)

	Returns itself.
	*/
	show(event) {
		CorrectorUtil.preventEventDefault(event);

		this.element.removeClass(this.classes.hide);
		this.element.find('.corrector-save').addClass(this.classes.focus);

		//invert if necessary
		this.checkOrientation();

		// give main textarea focus
		this.element.find(":input:first").focus();
		this.setupDraggables();

		return this.publish('show');
	}

	/*
	PUBLIC: Hides the Editor and fires a "hide" event.
	Can be used as an event callback and will call Event#preventDefault() on the supplied event.

	event - Event object provided if method is called by event listener (default:undefined)

	Examples:

	// Displays the editor.
	editor.hide()

	// Displays the editor on click (prevents default action).
	$('a.hide-editor').bind('click', editor.hide)

	Returns itself.
	*/
	hide(event) {
		CorrectorUtil.preventEventDefault(event);
		this.element.addClass(this.classes.hide);
		return this.publish('hide');
	}

	/*
	PUBLIC: Loads an correction into the Editor and displays it setting Editor#correction to the provided correction.
	It fires the "load" event providing the current correction subscribers can modify the correction before it updates the editor fields.

	correction - An correction Object to display for editing.

	Examples:

	// Displays the editor with the correction loaded.
	editor.load({text: 'My Correction'})
	editor.on('load', function(correction){ console.log correction.text })
		.load({text: 'My Correction'})
    // Outputs "My Correction"

	Returns itself.
	*/
	load(correction) {
		this.correction = correction;
		this.publish('load', [this.correction]);
		for(const field of this.fields) {
			field.load(field.element, this.correction);
		}
		return this.show();
	}

	/*
	PUBLIC: Hides the Editor and passes the correction to all registered fields so they can update its state.
	It then fires the "save" event so that other parties can further modify the correction.
	Can be used as an event callback and will call Event#preventDefault() on the supplied event.

	event - Event object provided if method is called by event listener (default:undefined)

	Examples:

	// Submits the editor.
	editor.submit()

	// Submits the editor on click (prevents default action).
	$('button.submit-editor').bind('click', editor.submit)

	// Appends "Comment: " to the correction comment text.
	editor.on('save', function(correction){ correction.text = "Comment: " + correction.text }).submit()

	Returns itself.
	*/
	submit(event) {
		CorrectorUtil.preventEventDefault(event);
		for(const field of this.fields) {
			field.submit(field.element, this.correction);
		}
		this.publish('save', [this.correction]);
		return this.hide()
	}

	/*
	Public: Adds an addional form field to the editor.
	Callbacks can be provided to update the view and anotations on load and submission.

	options - An options Object. Options are as follows:
		id     - A unique id for the form element will also be set as the "for" attrubute of a label if there is one. Defaults to a timestamp. (default: "corrector-field-{timestamp}")
		type   - Input type String. One of "input", "textarea", "checkbox", "select" (default: "input")
		label  - Label to display either in a label Element or as place-holder text depending on the type. (default: "")
		load   - Callback Function called when the editor is loaded with a new correction. Recieves the field <li> element and the correction to be loaded.
		submit - Callback Function called when the editor is submitted. Recieves the field <li> element and the correction to be updated.

	Examples:

	// Add a new input element.
	editor.addField({
		label: "Tags",

		// This is called when the editor is loaded use it to update your input.
		load: function(field, correction){
			// Do something with the correction.
			value = getTagString(correction.tags)
			$(field).find('input').val(value)
		}

		// This is called when the editor is submitted use it to retrieve data from your input and save it to the correction.
		submit: function(field, correction){
			value = $(field).find('input').val()
			correction.tags = getTagsFromString(value)
		}
	})

	// Add a new checkbox element.
	editor.addField({
		type: 'checkbox',
		id: 'corrector-field-my-checkbox',
		label: 'Allow anyone to see this correction',
		load: function(field, correction){
			// Check what state of input should be.
			if (checked) {
				$(field).find('input').attr('checked', 'checked')
			}
			else {
				$(field).find('input').removeAttr('checked')
			}
		}
		submit: function(field, correction){
			checked = $(field).find('input').is(':checked')
			// Do something.
		}
	})

	Returns the created <li> Element.
	*/
	addField(options) {
		let field = $.extend({
			id:     'corrector-field-' + CorrectorUtil.uuid(),
			type:   'input',
			label:  '',
			load:   function(){},
			submit: function(){}
		}, options);

		let input = null;
		const element = $('<li class="corrector-item" />');
		field.element = element[0];

		switch (field.type) {
			case 'textarea' :
				input = $('<textarea />');
				break;
			case 'input' :
			case 'checkbox' :
				input = $('<input />')
				break;
			case 'select' :
				input = $('<select />');
				break;
		}

		if (input == null) {
			return input;
		}

		element.append(input);

		input.attr({
			id: field.id,
			placeholder: field.label
		});

		if (field.type == 'checkbox') {
			input[0].type = 'checkbox';
			element.addClass('corrector-checkbox');
			element.append($('<label />', {for: field.id, html: field.label}));
		}

		this.element.find('ul:first').append(element);
		this.fields.push(field);

		return field.element;
	}

	checkOrientation() {
		super.checkOrientation();

		const list = this.element.find('ul');
		const controls = this.element.find('.corrector-controls');

		if (this.element.hasClass(this.classes.invert.y)) {
			controls.insertBefore(list);
		}
		else if (controls.is(':first-child')) {
			controls.insertAfter(list);
		}

		return this;
	}

	/*
	Sets up mouse events for resizing and dragging the editor window.
	window events are bound only when needed and throttled to only update the positions at most 60 times a second.

	Returns nothing.
	*/
	setupDraggables() {
		this.element.find('.corrector-resize').remove();

		let cornerItem;
		// Find the first/last item element depending on orientation
		if (this.element.hasClass(this.classes.invert.y)) {
			cornerItem = this.element.find('.corrector-item:last');
		}
		else {
			cornerItem = this.element.find('.corrector-item:first');
		}

		if (cornerItem) {
			$('<span class="corrector-resize"></span>').appendTo(cornerItem);
		}

		let mousedown = null;
		let classes   = this.classes;
		let editor    = this.element;
		let textarea  = null;
		let resize    = editor.find('.corrector-resize');
		let controls  = editor.find('.corrector-controls');
		let throttle  = false;

		const onMousedown = function(event) {
			if (event.target === this) {
				const mousedown = {
					element: this,
					top:     event.pageY,
					left:    event.pageX
				}

				// Find the first text area if there is one.
				textarea = editor.find('textarea:first');

				$(window).bind({
					'mouseup.corrections-editor-resize':   onMouseup,
					'mousemove.corrections-editor-resize': onMousemove
				})
				event.preventDefault()
			}
		}

		const onMouseup = function(){
			mousedown = null;
			$(window).unbind('.corrections-editor-resize');
		}

		const onMousemove = function(event) {
			if (mousedown && throttle === false) {
				const diff = {
					top:  event.pageY - mousedown.top,
					left: event.pageX - mousedown.left
				};

				if (mousedown.element === resize[0]) {
					const height = textarea.height();
					const width  = textarea.width();

					const directionX = editor.hasClass(classes.invert.x) ? -1 :  1;
					const directionY = editor.hasClass(classes.invert.y) ?  1 : -1;

					textarea.height( height + (diff.top  * directionY) );
					textarea.width( width  + (diff.left * directionX) );

					// Only update the mousedown object if the dimensions have changed, otherwise they have reached their minimum values.
					if (textarea.height() !== height) { mousedown.top  = event.pageY; }
					if (textarea.width()  !== width) { mousedown.left = event.pageX; }
				}
				else if (mousedown.element === controls[0]) {
					editor.css({
						top:  parseInt(editor.css('top'), 10)  + diff.top,
						left: parseInt(editor.css('left'), 10) + diff.left
					})

					mousedown.top  = event.pageY;
					mousedown.left = event.pageX;
				}

				throttle = true;
				setTimeout(function() {
					return throttle = false;
				}, 1000/60);
			}
		}

		resize.bind('mousedown', onMousedown);
		controls.bind('mousedown', onMousedown);
	}

	///////////////////////////////////////////////////////////////////////////////////////////
	//  CALLBACKS
	///////////////////////////////////////////////////////////////////////////////////////////

	/*
	Event callback. Listens for the following special keypresses.
		- escape: Hides the editor
		- enter:  Submits the editor

	event - A keydown Event object.

	Returns nothing
	*/
	processKeypress(event) {
		if (event.keyCode === 27) {
			// "Escape" key, abort.
			this.hide();
		}
		else if (event.keyCode === 13 && !event.shiftKey) {
			// If "return" was pressed without the shift key, we're done.
			this.submit();
		}
	}

	/*
	Event callback. Removes the focus class from the submit button when the cancel button is hovered.

	Returns nothing
	*/
	onCancelButtonMouseover() {
		this.element.find('.' + this.classes.focus).removeClass(this.classes.focus);
	}

}
